import LicencaRecebivelService from "@/services/LicencaRecebivelService";

export const licencaRecebivel = {
  namespaced: true,
  state: {
    licencaRecebivel: {},
  },
  actions: {
    getLicencaRecebivel({ commit }, payload) {
      return LicencaRecebivelService.GetLicencaRecebivel(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postLicencaRecebivel({ commit }, payload) {
      return LicencaRecebivelService.PostLicencaRecebivel(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putLicencaRecebivel({ commit }, payload) {
      return LicencaRecebivelService.PutLicencaRecebivel(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteLicencaRecebivel({ commit }, payload) {
      return LicencaRecebivelService.DeleteLicencaRecebivel(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getLicencaRecebivelOData({ commit }, payload) {
      return LicencaRecebivelService.GetLicencaRecebivelOData(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    postGerarFaturaLicencas({ commit }, payload) {
      return LicencaRecebivelService.PostGerarFaturaLicencas(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postGerarBoleto({ commit }, payload) {
      return LicencaRecebivelService.PostGerarBoleto(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postGerarCobrancaImediata({ commit }, payload) {
      return LicencaRecebivelService.PostGerarCobrancaImediata(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getConsultaCobrancaImediata({ commit }, payload) {
      return LicencaRecebivelService.GetConsultaCobrancaImediata(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postSolicitarMovimentacao({ commit }, payload) {
      return LicencaRecebivelService.PostSolicitarMovimentacao(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postBaixarBoleto({ commit }, payload) {
      return LicencaRecebivelService.PostBaixarBoleto(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postGerarBoletoMP({ commit }, payload) {
      return LicencaRecebivelService.PostGerarBoletoMP(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postGerarPIXMP({ commit }, payload) {
      return LicencaRecebivelService.PostGerarPIXMP(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getCobrancaMP({ commit }, payload) {
      return LicencaRecebivelService.GetCobrancaMP(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postMovimentacaoMP({ commit }, payload) {
      return LicencaRecebivelService.PostMovimentacaoMP(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postGerarBoletoAsaas({ commit }, payload) {
      return LicencaRecebivelService.PostGerarBoletoAsaas(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postGerarPIXAsaas({ commit }, payload) {
      return LicencaRecebivelService.PostGerarPIXAsaas(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postBaixarBoletoAsaas({ commit }, payload) {
      return LicencaRecebivelService.PostBaixarBoletoAsaas(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postGerarCardAsaas({ commit }, payload) {
      return LicencaRecebivelService.PostGerarCardAsaas(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postMovimentacaoAsaas({ commit }, payload) {
      return LicencaRecebivelService.PostMovimentacaoAsaas(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default licencaRecebivel;
